import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import HandoffRulesAPI from '../../api/handoffRules';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getHandoffRules($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  index: async ({ commit }, agentBotId) => {
    commit(types.SET_HANDOFF_RULE_UI_FLAG, { isFetching: true });
    try {
      const response = await HandoffRulesAPI.index(agentBotId);
      commit(types.SET_HANDOFF_RULES, response.data.payload);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_HANDOFF_RULE_UI_FLAG, { isFetching: false });
    }
  },

  confirm: async ({ commit }, { agentBotId, id, data }) => {
    commit(types.SET_HANDOFF_RULE_UI_FLAG, { isUpdating: true });
    try {
      const response = await HandoffRulesAPI.confirm(agentBotId, id, data);
      commit(types.ADD_HANDOFF_RULE, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_HANDOFF_RULE_UI_FLAG, { isUpdating: false });
    }
  },

  dismiss: async ({ commit }, { agentBotId, id }) => {
    commit(types.SET_HANDOFF_RULE_UI_FLAG, { isUpdating: true });
    try {
      await HandoffRulesAPI.dismiss(agentBotId, id);
      commit(types.DELETE_HANDOFF_RULE, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_HANDOFF_RULE_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_HANDOFF_RULE_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_HANDOFF_RULES]: MutationHelpers.set,
  [types.ADD_HANDOFF_RULE]: MutationHelpers.setSingleRecord,
  [types.DELETE_HANDOFF_RULE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
